import { acceptHMRUpdate, defineStore } from 'pinia'
import { UploadFlowPresignedS3 } from "@/types"

export const useUploadStore = defineStore('uploadStore', {
    state: (): {
        label: string,
        title: string,
        description: string,
        accept: string,
        workflow: undefined | UploadFlowPresignedS3,
        cancelText: string,
        submitText: string,
        method: "PUT" | "POST",
        action: string,
        editedRow: string,
        filename: string,
        filetype: string,
        temppath: string,
        loading: boolean,
    } => ({
        label: "⇧ Upload",
        title: "Upload File",
        description: "Select file to upload",
        accept: "*",
        workflow: {
            type: "presignedS3",
            getUrl:  "/uploads/url",
            reportUrl:  "/lono/multiStageUpload/$lono->id",
        },
        cancelText: "Cancel",
        submitText: "Upload",
        method: "POST",
        action: "",
        editedRow: "",
        filename: "",
        filetype: "",
        temppath: "",
        loading: false,
    }),
    actions: {
        closeModal() {
            const FORM = document.getElementById('upload-form') as HTMLFormElement
            FORM.reset()
            const DIALOG = document.getElementById('upload-modal') as HTMLDialogElement
            DIALOG.close()
            this.$reset()
        },
        openModal() {
            const DIALOG = document.getElementById('upload-modal') as HTMLDialogElement
            DIALOG.showModal()
        },

    },
})

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useUploadStore, import.meta.hot))
}
